import { render } from "./S281614A.vue?vue&type=template&id=935ed392"
const script = {}
script.render = render

export default script